export enum EventsNames {
  updateCustomer = 'Update customer',
  sampleIp = 'Sample IP',
  fetchOffer = 'Fetch Offer',
  getActiveOffer = 'Get Active Offer',
  fetchPreQualificationOffer = 'Fetch Pre-Qualification Offer',
  updateEmail = 'Update email',
  updateApplicationStatus = 'Update application Status',
  getApplicationStatus = 'Get application Status',
  selectPlan = 'Select Plan',
  emailVerify = 'Email Verify',
  checkUserMla = 'Check User Mla',
  updatePaymentMethod = 'Update Payment Method',
  validateDebitCard = 'Validate Debit Card',
  getDocument = 'Get Document',
  sendAgreement = 'Send Agreement',
  getUserLoadAgreement = 'Get User Loan Agreement',
  getUserRiskAgreement = 'Get User Risk Agreement',
  applyCharge = 'Apply Charge',
  updateUserSsnWithLoanAgreement = 'Update User Ssn With Loan Agreement',
  mlaCheck = 'MLA Check',
  getPurchaseInitialInfo = 'Get Purchase Initial Info',
  getFinalPageInfo = 'Get Final Page Info',
  getPurchaseInfo = 'Get Purchase Info',
  getCustomerInfo = 'Get Customer Info',
  voipError = 'Enter Phone Number - Voip Error',
  changeDownPayment = 'Change Down Payment',
  openAdditionalDownPaymentPopup = 'Open Down Payment Popup',
  submitPage = 'Submit Page',
  declinePage = 'Decline Page',
  logIn = 'Log In',
  checkPurchaseAmount = 'Check Purchase Amount',
  validateUser = 'Validate User',
  dateOfBirthVerificationPopup = 'Date Of Birth Verification Popup',
  validateDebitCardPage = 'Validate Debit Card Page',
  updateCustomerWaitingForPurchaseAmount = 'Customer Is Waiting For Purchase Amount',

  // Choose Your Plan
  clickOnPlan = 'Click On Plan',
  promotionPopupInitial = 'Promotion Popup Initial',
  promotionPopupReminder = 'Promotion Popup Reminder',

  // Email Verification
  resendVerificationEmail = 'Resend verification email',

  // Pages
  emailVerificationPage = 'Email Verification',
  landingPage = 'Landing Page',
  customerDetailsPage = 'Customer Details',
  optionsLoadingPage = 'Options Loading',
  purchaseAmountPendingPage = 'Purchase Amount Pending',
  purchaseAmountNotConfirmedPage = 'Purchase Amount Not Confirmed',
  chooseYourPlanPage = 'Choose Your Plan',
  paymentDetailsPage = 'Payment Details',
  agreementPage = 'Agreement',
  finalReviewPage = 'Final Review',
  processingPaymentPage = 'Processing Payment Page',
  postChargeFailedPage = 'Post Charge Failed Page',
  thankYouPage = 'Thank You',
  estimateThankYouPage = 'Estimate Thank You',
  technicalErrorPage = 'Technical Error Page',
  creditFreezePage = 'Credit Freeze Page',
  introPage = 'Intro Page',

  //Landing page Views
  welcomeView = 'Welcome View',
  otpView = 'OTP View',
  pinCodeView = 'Pin Code View',

  // FOR BUG - SBT-25629
  finalReviewWrongLoanAmountComparedWithPayments = 'Final Review Wrong Loan Amount Compared With Payments',

  // FOR BUG - SBT-37701
  componentForcedRefresh = 'Component forced refresh',
  componentFailedToLoadAfterForcedRefresh = 'Component failed to load after forced refresh',

  // Online_SDK MessageService errors
  messageServiceMessageDropped = 'Message Service: incoming message dropped (missing fields)',
  messageServiceDoneNoOriginWindow = 'Message Service: DONE not sent (no origin window)',
  messageServicePurchaseVerifiedNoOriginWindow = 'Message Service: PURCHASE_VERIFIED not sent (no origin window)',
  messageServiceCancelNoOriginWindow = 'Message Service: CANCEL not sent (no origin window)',
  messageServiceUserCancelNoOriginWindow = 'Message Service: USER_CANCEL not sent (no origin window)',
  messageServicePlaceInFlowNoOriginWindow = 'Message Service: PLACE_IN_FLOW not sent (no origin window)',

  // Pin Code
  sendPinCode = 'Send Pin Code',
  validatePinCode = 'Validate Pin Code',

  // Customer Approve Flow
  validateCustomerDetails = 'Validate Customer Details',
  validateCustomerDateOfBirth = 'Validate Customer Date Of Birth',

  // Cancellations
  cancelPurchase = 'Cancel Purchase',
  technicalIssueCancellation = 'Technical Issue Cancellation',
  customerPurchaseCancellation = 'Customer Purchase Cancellation',
  invalidCardTypeCancellation = 'Invalid Card Type Purchase Cancellation',
  ssnNotVerifiedCancellation = 'Ssn Not Verified Purchase Cancellation',
  expiredLink = 'Link is Expired',
  chargeFailed = 'Charge Failed',

  // Customer Verification (Mitek)
  customerVerificationPage = 'Customer Verification Page',
  customerVerificationSent = 'Customer Verification Sent',
  customerVerificationSmsFailed = 'Customer Verification SMS Failed',
  customerVerificationFailed = 'Customer Verification Failed',
  getCustomerVerificationLink = 'Get Customer Verification Link',
  sendSmsVerificationLink = 'Send Sms Verification Link',
  customerVerifiedPage = 'Customer Verified Page',

  // Back
  returnToChooseYourPlan = 'Return To Choose Your Plan',
  returnToPaymentDetails = 'Return To Payment Details',
  returnToEstimateThankYouPage = 'Return To Estimate Thank You Page',

  // Login
  refreshToken = 'Refresh Token',
  initialLogin = 'Initial Login',

  newPurchase = 'New Purchase',
  sessionExpiredByUI = 'Session Expired By UI',
  manualSessionExpiredByUI = 'Manual Session Expired By UI - modal was delayed',
  tryAgainAfterTechnicalError = 'Try Again After Technical Error',
  tryAgainAfterSessionExpiredByUI = 'Try Again After Session Expired By UI',
  tryAgainAfterDecline = 'Try Again After Decline',
  linkIsMissingAToken = 'Link Is Missing A Token',

  // MySunbit App Download
  androidDownloadClick = 'Download MySunbit Android App',
  iosDownloadClick = 'Download MySunbit Ios App',

  // Estimate only
  completeEstimate = 'Complete Estimate',

  // Request to checkout
  purchaseAmountApproved = 'Purchase Amount Approved',
  purchaseAmountUpdated = 'Purchase Amount Updated',
  purchaseAmountPendingSkip = 'Purchase Amount Pending Skip',

  // Redirecting
  redirectOnThankYouPage = 'Redirect On Final Page',
  redirectOnDeclinePage = 'Redirect On Decline Page',

  // Cip
  ssnRequired = 'Ssn Required',
  inputCustomerDetailsMismatch = 'Input Customer Details Mismatch',

  // WV Agreement Page
  wvAgreementPage = 'WV Agreement Page',
  wvAgreementConsent = 'WV Agreement Consent',
  csoDisclosurePopupOpened = 'CSO Disclosure Popup Opened',

  // CSO Documents
  getCSOAgreement = 'Get CSO Agreement',
  getCSODisclosure = 'Get CSO Disclosure',
  sendCSOAgreement = 'Send CSO Agreement',
  sendCSODisclosure = 'Send CSO Disclosure',

  // NOAA
  markNoaaPresented = 'Mark NOAA Presented',
  markNoaa5Presented = 'Mark NOAA5 Presented',
  markDocumentDisplayed = 'Mark Document Displayed',

  // Create Prequal Application
  createPrequalApplication = 'Create Prequal Application',
  getPrequalMerchantInfo = 'Get Prequal Merchant Info',
}
